import React, { useState } from "react";
import AdminSearchHeader from "../AdminSearchHeader";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { withRouter, useLocation } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { getDealerDropData } from "../../service/api";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Radio from "@material-ui/core/Radio"
import { categoryRoutes } from '../../Utils/appConstants';

const Header = (props) => {
  const tenant= localStorage.getItem("tenantId")? localStorage.getItem("tenantId"): "t001";
  const [showDealer, setShowDealer] = useState(null);
  const [showTenant, setShowTenant] = useState(null);
  const [dealerName, setDealerName] = useState('');
  const [selectedTenant, setSelectedTenant] = useState(tenant);
  const [dealerDrop, setDealerDrop] = useState([]);
  const [tenantDrop, setTenantDrop] = useState([
    { value: "t001", text: "TFS/LFS" },
    { value: "t002", text: "MFS" }]);
  const location = useLocation();

  const toggleShowTenant = (event) => {
    setShowTenant(event.currentTarget);
  };
  const toggleShowDealer = (event) => {
    setShowDealer(event.currentTarget);
  };

  React.useEffect(() => {
    let delaytime = ((localStorage.getItem("userToken") || localStorage.getItem("okta_access_token")) ? 100 : 2500);
    setTimeout(async () => {
      if (!localStorage.getItem("dealerCode") && (localStorage.getItem("userToken") || localStorage.getItem("okta_access_token"))) {
        getDealerDrop();
      }
      setDealerName(localStorage.getItem("dealerName"));
      setSelectedTenant(localStorage.getItem("tenantId"));
    }, delaytime);
  }, [localStorage.getItem("dealerName") , localStorage.getItem("tenantId")]);

  async function getDealerDrop() {
    let updateSelectedDealersNumber = ["ALL"];
    localStorage.setItem("selectedDealersNumber", updateSelectedDealersNumber);
    let dealerdata;
    try {
      let apiResponse = await getDealerDropData();
      dealerdata = apiResponse?.data;
      dealerdata?.forEach((item) => {
        item.checked = false;
      });
    } catch (error) {
      console.log("getDealerDropData", error);
    }
    setDealerDrop(dealerdata);
  }
  const handleCloseTenant = () => {
    setShowTenant(null);
  };
  const handleClose = () => {
    setShowDealer(null);
  };
  const handleChangeTenant =( titem) =>{
      setSelectedTenant(titem.value);
      localStorage.setItem("tenantId", titem.value);
      props.history.push("/grounded");
  }
  const handleChange = (ditem) => {
    let dealerData;
    let updateSelectedDealersNumber = [];
    if (localStorage.getItem("userToken") || localStorage.getItem("okta_access_token")) {
      if (!localStorage.getItem("dealerCode")) {
        dealerData = dealerDrop;
        dealerData.forEach((x) => {
          if (x.dealer_number === ditem.dealer_number) {
            x.checked = !ditem.checked;
          }
        });
        setDealerDrop([...dealerData]);
        let selectedDealersData = dealerData.filter((x) => x.checked);
        props.selectedDealers(selectedDealersData);
        selectedDealersData.forEach((item) => {
          updateSelectedDealersNumber.push(item.dealer_number);
        });
        if (updateSelectedDealersNumber?.length === 0) {
          updateSelectedDealersNumber = ["ALL"];
        }
      }
      else {
        updateSelectedDealersNumber = [localStorage.getItem("dealerCode")];
      }
      localStorage.setItem("selectedDealersNumber", updateSelectedDealersNumber);
    }
  };
  const hasTenant = localStorage.getItem("tenantId");
  const enableTenantDropDown = () => {
    return hasTenant && categoryRoutes.includes(location.pathname)

  };
  const isDealer = localStorage.getItem("dealerCode");
  const enableDealerDropDown = () => {
    return isDealer && categoryRoutes.includes(location.pathname)

  };
  const userName = localStorage.getItem("userName");
  return (
    <div className="container">
      <div className="brandingWrapper">
        <div className="imageHolder">
          <img src="waycycle.png" alt="waycycleLogo" width="213px" />
        </div>
        <div className="auctionSales">Auction Sales Platform </div>
      </div>
      {
        props.displayHeaderControls && !localStorage.getItem("dealerCode") && localStorage.getItem("okta_access_token") ?
        <AdminSearchHeader
          history={props.history}
        /> :
        <div style={{width: 1000}}>
          &nbsp;
        </div>
      }
      {
        props.displayHeaderControls &&
        <div className="rightContainer">
          <div className="dealerContianer">
            <div className='dealerName'>{"Tenant"}</div>
            {!enableTenantDropDown() &&
              <div className='tenantDropDown'>
                <IconButton aria-label="tenant" onClick={toggleShowTenant}>
                  <ArrowDropDownIcon />
                </IconButton>
              </div>
            }
          </div>
          <Menu
            id="tenant-menu"
            anchorEl={showTenant}
            keepMounted
            open={Boolean(showTenant)}
            onClose={handleCloseTenant}
            className="tenantmenu"
          >
            {
              
              tenantDrop  &&
              tenantDrop.map((titem, index) => (
                <MenuItem key={index}>
                  <FormGroup column="true">
             
                    <FormControlLabel
                      value={titem.value}   
                      control={
                        <Radio onChange={() => {
                          handleChangeTenant(titem);
                        }}
                        checked={selectedTenant === titem.value}
                        name="tenantgrp"
                        />
                      }
                      label={ titem.text  }
                    />
                  
                  </FormGroup>

                </MenuItem>
              ))}
          </Menu>

          <div className="dealerContianer">
            <div className='dealerName'>{isDealer ? dealerName : "Dealer Name"}</div>
            {!enableDealerDropDown() &&
              <div className='dealerDropDown'>
                <IconButton aria-label="dealer" onClick={toggleShowDealer}>
                  <ArrowDropDownIcon />
                </IconButton>
              </div>
            }
          </div>
          <Menu
            id="dealer-menu"
            anchorEl={showDealer}
            keepMounted
            open={Boolean(showDealer)}
            onClose={handleClose}
            className="dealermenu"
          >
            {
              dealerDrop &&
              dealerDrop.map((ditem, index) => (
                <MenuItem key={index}>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={ditem.checked}
                          onChange={() => {
                            handleChange(ditem);
                          }}
                          value={ditem.dealer_number}
                  
                        />
                      }
                      label={ditem.dealer_name + "(" + ditem.dealer_number + ")"}
                    />
                  </FormGroup>
                </MenuItem>
              ))}
          </Menu>
          {!isDealer && userName &&
            <div className="userInfo">{userName}</div>}
        </div>
      }
    </div>
  );
};

export default withRouter(Header);